<template>
    <div class="root">
        <div class="col-12">
            <div class="row">
                <div class="col-3">
                    <template-draft-listing @template-selected="previewedTemplateId = $event"></template-draft-listing>
                </div>

                <div class="col-3" v-if="showBuilderTemplates">
                    <template-primary-listing @template-selected="previewedTemplateId = $event"></template-primary-listing>
                </div>
                
                <div class="col-3" v-if="showPublishableTemplates">
                    <template-publishable-listing @template-selected="previewedTemplateId = $event"></template-publishable-listing>
                </div>

                <div class="col" v-if="previewedTemplateId">
                    <template-preview v-bind:template-id="previewedTemplateId"></template-preview>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TemplateDraftListing from './Listings/TemplateDraftListing.vue';
    import TemplatePublishableListing from './Listings/TemplatePublishableListing.vue';
    import TemplatePrimaryListing from './Listings/TemplatePrimaryListing.vue';
    import TemplatePreview from './TemplatePreview.vue';
    
    export default {
        name: "template-manager-index",
        components: {
            TemplateDraftListing,
            TemplatePublishableListing,
            TemplatePrimaryListing,
            TemplatePreview
        },
        data() {
            return {
                previewedTemplateId: null
            }
        },
        props: {
            showBuilderTemplates: Boolean,
            showPublishableTemplates: Boolean
        }
    };
</script>

<style scoped>

</style>
